import { request } from '../utils/request'
import { apiURL } from '../utils/url'
import { apiRoutes } from '../routes'
import { NextPageContext } from 'next'

export interface conciergeHairType {
  readonly id: number
  readonly name: string
}

export type ConciergeHairTypes = conciergeHairType[]

export function conciergeHairTypeJSON(json: any): conciergeHairType {
  return {
    id: json.id,
    name: json.name,
  }
}

export function fromJSON(json: any): ConciergeHairTypes {
  return json.concierge_hair_types.map((concierge_hair_type: any) => conciergeHairTypeJSON(concierge_hair_type))
}

export async function fetchConciergeHairType(req?: NextPageContext['req']): Promise<ConciergeHairTypes> {
  const response = await request(apiURL(apiRoutes.conciergeHairTypes), {}, req)
  if (!response.ok) {
    throw new Error('Failed to fetch concierge hair types')
  }
  const json = await response.json()
  return fromJSON(json)
}
